const HEADER_HOST_SELECTOR = '[data-storeeel-header-host]';

export const getHeaderHosts = (root = document) => {
  if (!root?.querySelectorAll) return [];
  return Array.from(root.querySelectorAll(HEADER_HOST_SELECTOR));
};

export const getHeaderHost = (root = document) => {
  if (!root?.querySelector) return null;
  return root.querySelector(HEADER_HOST_SELECTOR);
};

export const queryHeaderElements = (selector, root = document) => {
  const hosts = getHeaderHosts(root);
  if (hosts.length === 0) {
    return root?.querySelectorAll ? Array.from(root.querySelectorAll(selector)) : [];
  }
  const elements = [];
  hosts.forEach((host) => {
    if (host.shadowRoot) {
      elements.push(...host.shadowRoot.querySelectorAll(selector));
    }
  });
  return elements;
};

export const queryHeaderElement = (selector, root = document) => {
  const host = getHeaderHost(root);
  if (host?.shadowRoot) {
    return host.shadowRoot.querySelector(selector);
  }
  return root?.querySelector ? root.querySelector(selector) : null;
};

export const queryHeaderElementsInElement = (selector, element) => {
  if (!element?.querySelector) return [];
  const host = element.querySelector(HEADER_HOST_SELECTOR);
  if (host?.shadowRoot) {
    return Array.from(host.shadowRoot.querySelectorAll(selector));
  }
  return Array.from(element.querySelectorAll(selector));
};
